import { RootState } from 'types';
import { ISceneEditorState } from '.';

export const selectSceneEditor = (state: RootState): ISceneEditorState => state.sceneEditor;
